import { render } from "./QualityDot.vue?vue&type=template&id=2e894668&lang=pug"
import script from "./QualityDot.vue?vue&type=script&lang=js"
export * from "./QualityDot.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/valley_watch_firm/fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__